import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import classNames from "classnames";
import CircularProgress from "@material-ui/core/CircularProgress";

class Maillog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mails: [],
      open: "",
      active: null,
      recipient: "",
      count: 50
    };
  }

  setOpen = id =>
    this.setState({ open: id, active: null }, () => this.getDetails(id));

  componentDidMount() {
    this.searchQuery();
  }

  async searchQuery() {
    const response = await axios.post("/api/operations/mail/outbound", {
      count: this.state.count,
      recipient: this.state.recipient
    });
    this.setState({
      mails: response.data.Messages,
      open: "",
      active: null
    });
  }

  async getDetails(id) {
    const response = await axios.post("/api/operations/mail/details", {
      id: id
    });
    this.setState({
      active: response.data
    });
  }

  render() {
    const date_format = "HH:mm DD.MM YYYY";

    const { mails, open, active } = this.state;

    return (
      <div className="main-container">
        <div className="grid-x">
          <div className="medium-9 cell">
            <div className="primary-content">
              <div className="inner">
                <h3>Epost logg</h3>
                {mails.length < 1 ? (
                  <CircularProgress color="secondary" size={20} />
                ) : null}
                <table>
                  <thead>
                    <tr>
                      <th>Tidspunkt</th>
                      <th>Status</th>
                      <th>Beskrivelse</th>
                      <th>Mottager</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mails.map((item, i) => (
                      <React.Fragment key={item.MessageID}>
                        <tr className="spacer"></tr>
                        <tr
                          onClick={e => this.setOpen(item.MessageID)}
                          className={classNames(item.Status, { odd: i % 2 })}
                        >
                          <td>{moment(item.ReceivedAt).format(date_format)}</td>
                          <td>{item.Status}</td>
                          <td>{item.Subject}</td>
                          <td>{item.To.map((to, ind) => to.Email)}</td>
                        </tr>
                        {open === item.MessageID ? (
                          <tr className="modal-open">
                            <td colSpan="4">
                              <div>
                                {active ? (
                                  active.MessageEvents.map((event, num) => (
                                    <div>
                                      {moment(event.ReceivedAt).format(
                                        date_format
                                      )}{" "}
                                      {" - "}
                                      {event.Type}
                                      {" - "}
                                      {event.Recipient}
                                    </div>
                                  ))
                                ) : (
                                  <CircularProgress
                                    color="secondary"
                                    size={20}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        ) : null}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="medium-3 cell">
            <div className="sidebar-holder"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Maillog;
